<template>
  <div class="setting-flow-wrap" v-loading="loading">
    <!-- 头部控制栏  -->
    <div class="setting-flow-wrap-header">
      <!-- 左侧返回 -->
      <div class="flow-header-back">
        <i class="el-icon-arrow-left icon-button" @click="goBack" />
      </div>
      <!-- 步骤条 -->
      <nav ref="step" class="setting-flow-steps">
        <div
          v-for="(item, index) in asyncComponent"
          :key="index"
          class="steps-item"
          :class="{ 'item-active': active === index }"
        >
          {{ $t(item.name) }}
        </div>
      </nav>
      <!-- 右侧控制栏 -->
      <div class="release">
        <el-button type="primary" size="small" plain v-if="active > 0" @click="handleChangeStep(true)">{{
          $t('422')
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          plain
          v-if="active < asyncComponent.length - 1"
          @click="handleChangeStep(false)"
          >{{ $t('331') }}</el-button
        >
        <el-button type="primary" size="small" v-if="active === asyncComponent.length - 1" @click="handlerRelease">{{
          $t('161')
        }}</el-button>
      </div>
    </div>
    <!-- 内容渲染 -->
    <div class="setting-flow-wrap-content">
      <!-- 自定义滚动条 -->
      <el-scrollbar wrap-class="scrollbar-wrapper">
        <!-- 动态组件渲染 -->
        <component
          :is="asyncComponent[active].component"
          :base="flowData.workFlowDef"
          :select-data="selectData"
          :form="flowData.form"
          :title="flowData.workFlowDef.name"
          :source="flowData"
          :base-info="flowData.workFlowDef"
          :director-level="flowData.directorMaxLevel"
          key="component"
          ref="stepDom"
        />
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import Basic from './basic'
import Design from './design'
import CustomForm from './form'
import { sourceData } from './design/examples'
import { getWorkFlow, workFlowSave, selectApi, workUpdateSave } from 'api/flow'
import { verification } from './design/rules'
import { basicComponents, baseInfo, initForm } from './form/enum'
import '../style/index.scss'
export default {
  components: {
    Basic,
    Design,
    CustomForm
  },
  data() {
    return {
      loading: false,
      // 当前步骤条
      active: 0,
      // 审批流下拉选项
      selectData: {
        audit: [],
        group: [],
        status: []
      },
      // 审批流出实话数据
      flowData: {
        form: initForm(),
        tableId: 1,
        workFlowVersionId: '',
        workFlowDef: baseInfo(),
        nodeConfig: JSON.parse(JSON.stringify(sourceData)), // 审批流信息
        directorMaxLevel: 10, // 审核人 部门负责人筛选项
        flowPermission: []
      }
    }
  },
  computed: {
    // 旧的审批流区分表单配置
    asyncComponent() {
      const arr = [...basicComponents]
      const { type } = this.flowData.workFlowDef
      if (type !== 2) arr.splice(1, 1)
      return arr
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getFlow()
      this.selectApi()
      // 折叠MENU菜单
      this.$nextTick(() => {
        this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
      })
    },
    // 返回上一步
    goBack() {
      this.$confirm(this.$t('280164ef'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(() => {
        this.$router.push({
          path: '/approval/config'
        })
      })
    },
    // 步骤条切换
    // @param { bool } isLast
    // 上一步或下一步
    handleChangeStep(isLast) {
      if (!isLast) {
        const state = this.$refs.stepDom.doSubmit ? this.$refs.stepDom.doSubmit() : true
        if (!state) {
          this.$message.error(this.$t('i18n.4fdf2bec1aeb43c7bddb15a61c8ad13f'))
          return false
        }
      }
      this.active = isLast ? this.active - 1 : this.active + 1
    },
    // 获取下拉框数据
    selectApi() {
      selectApi().then(res => {
        if (res && res.code === 1) this.selectData = res.data
      })
    },
    // 获取数据
    async getFlow() {
      this.loading = true
      const { query } = this.$route
      // 无id为新增，不用获取详情
      if (!query.fid) {
        this.loading = false
        const { params } = this.$route.query
        if (!params) return this.$router.go(-1)
        const base = JSON.parse(params)
        this.flowData.workFlowDef = { ...baseInfo(), ...base }
        return false
      }
      const { data } = await getWorkFlow({ id: window.atob(query.fid) })
      this.flowData = data.flow_request || data
      this.loading = false
    },
    // 发布
    async handlerRelease() {
      this.$refs.stepDom.save && this.$refs.stepDom.save()
      // 审批流校验
      const result = verification(this.flowData.nodeConfig)
      if (!result) {
        this.$message({
          message: this.$t('work_rule_63'),
          type: 'warning'
        })
        return
      }
      const msg = {
        workflow_request: JSON.stringify(this.flowData)
      }
      let res
      // 表单提交
      if (this.$route.query.fid) {
        msg.id = window.atob(this.$route.query.fid)
        res = await workUpdateSave(msg)
        if (res && res.code === 1) {
          this.$message({
            message: this.$t('886'),
            type: 'success'
          })
        }
      } else {
        msg.audit_type = this.flowData.workFlowDef.audit_type
        res = await workFlowSave(msg)
        if (res && res.code === 1) {
          const status = res.data.status
          let msg = this.$t('work_rule_64')
          if (status === 1) {
            msg = `${this.$t('work_rule_65')}<span style="color: #5D51DA">${this.$t('work_rule_66')}</span>，${this.$t(
              'work_rule_67'
            )}`
          }
          this.$message({
            dangerouslyUseHTMLString: true,
            message: msg,
            type: status === 1 ? 'warning' : 'success'
          })
        }
      }
      if (res && res.code === 1) {
        this.$router.push('/approval/config')
      }
    }
  }
}
</script>
